import { createApp } from 'vue';
import LoadingReport from "../components/LoadingReport.vue";

const appElements = document.querySelectorAll('.vue-loading-page');
Array.from(appElements).forEach(element => {
  const isLoading = true;
  const haveSteps = true;

  createApp(LoadingReport, {
    isLoading,
    haveSteps,
  }).mount(element);
});
